import { useContext, useEffect } from 'react';
import { useJwtClaims } from '../../../../Service/Context/AuthContext';
import { SemanticFormS } from '../../../../Service/restapi/semanticFormService';
import { BookitupFormContext } from '../../../../Service/Context/BookitupFormContext';
import CodeWithCopy from '../../../../Atoms/CodeWithCopy';
import { ThemeText } from '../../../../Atoms/ThemeText';

const FormCode = () => {
  const { profileId } = useJwtClaims();
  const { bookitupForm, handleChange } = useContext(BookitupFormContext);
  const { id: formId, outOfSync } = bookitupForm ?? {};

  useEffect(() => {
    if (outOfSync && formId) {
      SemanticFormS.syncFormFiles(formId).then((synced) => {
        if (synced) {
          handleChange({ outOfSync: false });
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [outOfSync, formId]);

  if (!formId) {
    return null;
  }

  return (
    <>
      <ThemeText weight="bolder" size="lg" mb="md" mt="md">
        iFrame
      </ThemeText>
      <CodeWithCopy content={SemanticFormS.generateIframeCode(formId, profileId)} />
      <ThemeText weight="bolder" size="lg" mb="md" mt="md">
        Script
      </ThemeText>
      <CodeWithCopy content={SemanticFormS.generateJsCode(formId, profileId)} />
    </>
  );
};

export default FormCode;
